// extracted by mini-css-extract-plugin
export default {"fileWrapper":"documents_fileWrapper__CzCQi","serviceAppointmentTypeTag":"documents_serviceAppointmentTypeTag__bkoGe","iconCentered":"documents_iconCentered__v4hCC"};